import React, { useContext, useState } from 'react';
import { ViewList as ViewListIcon } from '@mui/icons-material';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import Tooltip from '@mui/material/Tooltip';
import { GridTableContext } from '../contexts';

export function ColumnVisibilityButton(): JSX.Element {
  const {
    instance: { allColumns, toggleHideColumn },
    setColumnsOrder
  } = useContext(GridTableContext);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };
  const handleToggleColumn = (columnId: string, isVisible: boolean): void => {
    toggleHideColumn(columnId, isVisible);
    setColumnsOrder((prevOrder) =>
      prevOrder.map((col) => (col.id === columnId ? { ...col, isVisible: !isVisible } : col))
    );
  };

  const isOpen = Boolean(anchorEl);
  const label = 'Manage Columns';

  return (
    <Box>
      <Tooltip title={label}>
        <IconButton onClick={handleOpen}>
          <ViewListIcon />
        </IconButton>
      </Tooltip>
      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        sx={{
          marginLeft: 5
        }}
      >
        <Box sx={{ padding: 2, maxWidth: 300, display: 'flex', flexDirection: 'column' }}>
          {allColumns.map((column) => (
            <FormControlLabel
              key={column.id}
              control={
                <Checkbox
                  checked={column.isVisible}
                  onChange={() => handleToggleColumn(column.id, column.isVisible)}
                />
              }
              label={column.Header as string}
            />
          ))}
        </Box>
      </Popover>
    </Box>
  );
}
